import { SelectInputData } from '../interfaces/select-input-data.interface';

export interface UnitFilterDictionary {
  buildings: SelectInputData<string>[];
  staircases: SelectInputData<string>[];
  numbers: SelectInputData<string>[];
}
export namespace UnitFilterDictionary {
  export function empty(): UnitFilterDictionary {
    return { buildings: [], staircases: [], numbers: [] };
  }
}
